import * as React from 'react'

// ? replace with https://github.com/thebuilder/react-intersection-observer
// TODO does this need to check the initial state (on mount or useEffect re-run) before setting it?
const initialState = false
const TOP_TOLERANCE_PX = 10

/**
 * observes the position of sticky element and provides the information about its state
 * return `true` if the element is `stuck`, false otherwise
 */
export const useStickyState = (elementId: Nullable<string>) => {
  const [isStuck, setIsStuck] = React.useState(false)

  const handleIntersection: IntersectionObserverCallback = React.useCallback(([entry]) => {
    const isTopIntersection = entry.boundingClientRect.top <= TOP_TOLERANCE_PX
    setIsStuck(entry.intersectionRatio < 1 && isTopIntersection)
  }, [])

  // when the element changes, connect the IntersectionObserver & subscribe to intersection changes
  React.useEffect(() => {
    // clear the state if it was changed before for another element
    setIsStuck(initialState)

    const element = elementId && document.getElementById(elementId)

    if (!element) {
      return
    }

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '-1px 0px 0px 0px',
      threshold: [1],
    })

    observer.observe(element)

    // don’t forget to clear the subscription on unmount or element change
    return () => {
      observer.disconnect()
    }
  }, [elementId, handleIntersection])

  return isStuck
}
